import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import { CircularProgress } from '@zn-material-ui'
import { throttle } from 'lodash'
import { initCaptcha } from './captcha'
import useStyles from './style'
import { transform } from '@utils/intl_lang'

const initCaptchaThrottle = throttle(initCaptcha, 6000)

export type SuccessType = {
  geetest_challenge: string
  geetest_seccode: string
  geetest_validate: string
}

export type CaptchaType = {
  reset: () => void
  appendTo: (dom: HTMLElement) => void
  onReady: () => void
  onSuccess: () => void
  onError: (e: Error) => void
  [x: string]: any
}
interface IProps {
  onInit: (captObj: CaptchaType | null) => void
  onSuccess: (success: SuccessType) => void
  /** 免密登录 201，账密登录 202，课程打卡 800 */
  type: '800' | '201' | '202'
  /** 登陆滑动弹窗位置单独设置 */
  loginType?: number
}

const SliderCaptcha: React.FC<IProps> = props => {
  const sliderRef = useRef<HTMLDivElement>(null)
  const [captObj, setCaptchaObj] = useState(null as CaptchaType | null)

  const classes = useStyles()
  const appendOrResetCaptcha = (isReset = false) => {
    // reset() 会保留上一个验证弹框的DOM，这里手动清除掉;
    const lastGeetestPopup = document.querySelector('.geetest_popup')
    if (lastGeetestPopup) {
      lastGeetestPopup.parentNode?.removeChild(lastGeetestPopup)
    }

    if (!captObj || !sliderRef.current) {
      return
    }
    if (isReset && captObj) {
      captObj.reset()
      return
    }
    captObj.appendTo(sliderRef.current)
  }
  const handler = (captchaObj: any) => {
    props.onInit(captchaObj)
    captchaObj
      .onReady(() => {
        setCaptchaObj(captchaObj)
      })
      .onSuccess(() => {
        const res = captchaObj.getValidate()
        props.onSuccess(res)
      })
      .onError((e: any) => {
        captchaObj.destroy()
        // 当h5页面切到后台运行，js计数器无法计数 或者 当页面被挂起，长时间不操作，50分钟后，验证流会被销毁，后端会返回error_21,需要将原验证销毁，重新初始化
        if (
          JSON.stringify(e) === '{}' ||
          !e.code ||
          e.code === 'error_21' ||
          e.code === 'error_12' ||
          e.code === 'error_01'
        ) {
          if (e.code === 'error_12') {
            // '尝试次数过多，请重新验证'
            global.$message(transform('components_many_attempts'))
          }
          if (e.code === 'error_01') {
            // '刷新次数过多，请重新验证'
            global.$message(transform('components_many_attempts'))
          }
          if (window.wiseAPM && window.wiseAPM.customError) {
            window.wiseAPM.customError({
              message: `SliderCaptchaError_${window.location.hash}`,
              stack: JSON.stringify(e),
              sourceURL: window.location.href,
            })
          }
          initCaptchaThrottle(+props.type, handler)
        } else {
          props.onInit(null)
        }
      })
  }

  const init = async () => {
    try {
      const isValid = await initCaptcha(+props.type, handler)
      if (!isValid) {
        props.onInit(null)
      }
    } catch (e) {
      props.onInit(null)
    }
  }
  useEffect(() => {
    init()
  }, [])

  useLayoutEffect(() => {
    appendOrResetCaptcha()
  }, [captObj])

  return (
    <>
      <div
        id="captcha-pupup"
        className={
          props.loginType === 1
            ? classes.postionRight
            : (props.loginType === 2 ? classes.postionLeft : '')
        }
      />
      <div className={classes.wrapper} ref={sliderRef}>
        <CircularProgress className={classes.loading} />
      </div>
    </>
  )
}

export default SliderCaptcha
